<template>
    <v-btn variant="flat" prepend-icon="mdi-cancel" color="red-lighten-2" class="mr-1" @click="confirmCancelJob" :loading="loading">Cancel Job</v-btn>
    <v-btn @click="openJobReworkDialog(entityRecord)"
           v-if="entityRecord.status != $constants.jobs.JOBSTAT_SCHEDULE"
           prepend-icon="mdi-recycle"
           variant="flat"
           color="grey-lighten-2"
           class="mr-1"
           @click.stop>Add Rework</v-btn>
    <add-to-job :job="entityRecord"></add-to-job>
    <job-reset v-if="hasManagerAccess && $windowWidth > 960" :job="entityRecord"></job-reset>
    <load-nuwall v-if="hasManagerAccess && entityRecord.contact && entityRecord.contact.isNuwall" :job="entityRecord"></load-nuwall>
    <job-complete v-if="hasManagerAccess && $windowWidth > 960" :job="entityRecord"></job-complete>
    <v-btn :to="'/'+$constants.entities.Job.ROUTE+entityRecord.id+'/jobsheet/'"
           color="grey-lighten-2"
           prepend-icon="mdi-printer"
           class="mr-1"
           variant="flat"
           @click.stop>
        Job Card
    </v-btn>
</template>
<style scoped>
</style>
<script>
    import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false
        };
    }
    export default {
        name: "JobToolbar",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
        },
        methods: {
            ...mapMutations([
                "setEntityRecord"
            ]),
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "openJobReworkDialog"
            ]),
            confirmCancelJob() {
                this.$confirm(
                    {
                        message: 'This will cancel this job and void the invoice in Xero. This cannot be undone. Are you sure?',
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                this.loading = true;
                                this.$api.post(this.$constants.entities.Job.ROUTE + 'cancel', { id: this.entityRecord.id })
                                    .then(res => {
                                        this.loading = false;
                                        this.setEntityRecord(res.data);
                                    })
                                    .catch(error => {
                                        this.loading = false;
                                        this.showErrorSnack('There was an error cancelling the job.');
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
            ...mapState({
                entity: (state) => state.entities.entity,
                entityRecord: (state) => state.entities.entityRecord,
                entityRecordLoading: (state) => state.entities.entityRecordLoading
            }),
            ...mapGetters(['hasManagerAccess']),
        },
    };
</script>